// removed by extract-text-webpack-plugin
module.exports = {"card":"card__33pTw","cardContainer":"cardContainer__Gc5XG","pageContainer":"pageContainer__3mePa"};


//////////////////
// WEBPACK FOOTER
// ./components/pages/style.css
// module id = 1ccK
// module chunks = 1